export default "__VITE_ASSET__BRUe0sxa__"